import { Component, OnInit, OnChanges, Input, Injectable, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DataService } from "app/shared/services/dataService";
import { ResourceCenterService } from "app/shared/services/resourceCenterService";
import {FlatTreeControl} from '@angular/cdk/tree';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'app/shared/services/userService';
import { DynamicDatabase, DynamicDataSource, DynamicFlatNode } from 'app/shared/services/treeUtilsService';

@Component({
  selector: 'app-resource-documents',
  templateUrl: './resource-documents.component.html',
  styleUrls: ['./resource-documents.component.scss']
})
export class ResourceDocumentsComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Input() isAdminUser: boolean = false;
  @Input() resourceDetails: Array<any> = [];
  @Input() jurisdictionOptions: Array<any> =[];
  @Input() readOnly = false;
  public jurisdiction = "general"

  private database:DynamicDatabase;
  private newFolderName:string;
  isNewFolderToggled:boolean = false;


  constructor(private dataService: DataService, private resourceCenterService:ResourceCenterService,
    private snackBar: MatSnackBar,private userService: UserService) {
    this.database = new DynamicDatabase();
    this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new DynamicDataSource(this.treeControl, this.database);
   }

  treeControl: FlatTreeControl<DynamicFlatNode>;

  dataSource: DynamicDataSource;

  formatFolderName(folderName: string): string {
    const parts = folderName.split('-');
    if (parts.length === 1) {
      return folderName;
    }
    const formattedName = parts.slice(0, -1).join('-');
    return formattedName;
  }

  getLevel = (node: DynamicFlatNode) => node.level;

  isExpandable = (node: DynamicFlatNode) => node.expandable;

  hasChild = (_: number, _nodeData: DynamicFlatNode) => _nodeData.expandable;

  ngOnInit() {

     this.jurisdiction = this.jurisdictionOptions[0].name;
     const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
      this.resourceCenterService.fetchResourceDetails(formattedJurisdiction)
      .then((response) => this.handleFetchResourceDetailsResponse(response));

  }
  onSelectJurisdiction(){
    const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
    this.resourceCenterService.fetchResourceDetails(formattedJurisdiction)
      .then((response) => this.handleFetchResourceDetailsResponse(response));

  }

   onCloseModal(event: any) {
    this.isNewFolderToggled = false;
    this.closeModalEvent.emit(false);
  }

   handleFetchResourceDetailsResponse(resourceDetails:any):any{
    this.resourceDetails = resourceDetails.Blobs;

    let pathAsArray = this.resourceDetails.map(r => r.split('/'));
    let map = new Map<string, string[]>();
    let rootNodes:string[] = resourceDetails.Directories.map(d => {
      map.set(d.Directory, []); //re-use this map instead of another loop
      return d.Directory
    });

    pathAsArray.forEach(element => {
      let key;
      if(element.length > 1){
        key = element[0];
      }else{
        key = "General";
      }

      if(map.get(key) === undefined) {
        map.set(key, []);
      }

      map.get(key).push(element[element.length-1]);
    });

    this.database.rootLevelNodes = rootNodes;
    this.database.dataMap = map;

    this.dataSource.data = this.database.initialData();
   }

   getFolderCount(node){
    return this.database.dataMap.get(node.item).length;
   }

   toogleCreateFolder():boolean
   {
    this.isNewFolderToggled = !this.isNewFolderToggled;
    return this.isNewFolderToggled;
   }

   createFolder(newFolderName){
    if(!newFolderName) {
      this.snackBar.open('Folder name required.', 'close',  {duration: 5000});
      return;
    }
    
    const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
    const folderWithJurisdiction = `${newFolderName}-${formattedJurisdiction}`;    

    if(this.database.rootLevelNodes.includes(folderWithJurisdiction)) {
      this.snackBar.open('Folder already exists.', 'close',  {duration: 5000});
      return;
    }

    this.resourceCenterService.createFolder(folderWithJurisdiction, formattedJurisdiction).then(res =>
      {
        this.resourceCenterService.fetchResourceDetails(formattedJurisdiction)
        .then((response) => {
          this.handleFetchResourceDetailsResponse(response);
          this.isNewFolderToggled = false;
          this.newFolderName = null;
        });
      });
   }

   deleteFolder(node){
    if(confirm("Are you sure you want to delete this folder?")) {
      const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
      this.resourceCenterService.deleteFolder(node.item,formattedJurisdiction).then(res => {
        this.resourceCenterService.fetchResourceDetails(formattedJurisdiction)
        .then((response) => this.handleFetchResourceDetailsResponse(response));
      });
    }
   }

  resourceFileChange(event: { target: { files: Array<any> }}, node) {
    let path = node.item;
    if(path === 'General') path = '';

    let file;
    if(event.target.files && event.target.files[0]){
      file = event.target.files[0];
    }
    const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
    this.dataService.uploadDocuments(file, path, formattedJurisdiction)
      .then(res => {
        this.snackBar.open('File Uploaded', 'close',  {duration: 3000});
        this.refresh(event);
      })
      .catch(error => {
        alert('An error occurred\n' + error)
      });
  }

  getParentFolder(folder, aggregatedPath:string){
    let parent;
    for (let entry of Array.from(this.database.dataMap.entries())) {
      let key = entry[0];
      let value = entry[1];
      if(value.includes(folder)) {
        parent = key;
        break;
      }
    }
    return parent;
  }

  refresh(event: any) {
    const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
    this.resourceCenterService.fetchResourceDetails(formattedJurisdiction).then((response) => {
      this.handleFetchResourceDetailsResponse(response)
    });
  }

  deleteResources(node: any) {
    if(confirm("Are you sure you want to delete this resource?")) {
      let resource = '';
      let path: any = this.getParentFolder(node.item, node.item);

      if(!path || path == 'General') resource = node.item;
      else resource = `${path}/${node.item}`;
      const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
      this.resourceCenterService.deleteResource(resource, formattedJurisdiction)
        .then(res => {
          this.refresh(event);
        })
        .catch(error => alert('An error occurred\n' + error.json()));
    }
  }

  downloadResources(node) {
    let resource = '';
    let path: any = this.getParentFolder(node.item, node.item);

    if(!path || path == 'General') resource = node.item;
    else resource = `${path}/${node.item}`;
    const formattedJurisdiction = this.jurisdiction.replace(/\s+/g, '_');
    this.resourceCenterService.downloadResource(resource, formattedJurisdiction)
      .then(res => {
        this.downloadBlob(res, node.item);
    });
  }


  downloadBlob(data: any, name: any) {
    let newBlob = new Blob([data], { type: "application/octet-stream" });
    if (typeof window.navigator.msSaveBlob !== 'undefined'){ //Stupid windows only hack (IE and Edge)
      window.navigator.msSaveBlob(newBlob, name);
    } else {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      let url = window.URL.createObjectURL(newBlob);
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  restrictSpecialCharacters(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  onFileDropped(node, fileList) {
    const event = { target: { files: fileList } };
    this.resourceFileChange(event, node)
  }
}

